import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";

import { useAppCapabilities } from "@/core/hooks/use-app-capabilities";
import {
  getCurrentUserInvitationsQueryKey,
  getCurrentUserPermissionQueryKey,
  getCurrentUserQueryKey,
  jwtLogoutMutation,
  workosLogoutMutation,
} from "@/openapi/@tanstack/react-query.gen";

function redirectTo(url: string) {
  globalThis.location.href = url;
}

export const useLogout = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const appCapabilities = useAppCapabilities();

  const clearUserQueries = () => {
    queryClient.removeQueries({ queryKey: getCurrentUserQueryKey() });
    queryClient.removeQueries({
      queryKey: getCurrentUserInvitationsQueryKey(),
    });
    queryClient.removeQueries({
      queryKey: getCurrentUserPermissionQueryKey(),
    });
  };

  const navigateToSignIn = () => {
    navigate({ to: "/auth/sign-in", replace: true });
  };

  const jwtLogout = useMutation({
    ...jwtLogoutMutation(),
    onSuccess: () => {
      clearUserQueries();
      navigateToSignIn();
    },
    onError: () => {
      clearUserQueries();
      navigateToSignIn();
    },
  });

  const workosLogout = useMutation({
    ...workosLogoutMutation(),
    onSuccess: (data) => {
      clearUserQueries();
      if (data.logout_url) {
        redirectTo(data.logout_url);
        return;
      }
      navigateToSignIn();
    },
    onError: () => {
      clearUserQueries();
      navigateToSignIn();
    },
  });

  return appCapabilities.workos ? workosLogout : jwtLogout;
};
